// Substance-Specific Pages (housing-focused; no clinical treatment claims)
const mk = (o) => o;
const pages = [
  mk({
    slug: '/drug-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 2',
    name: 'Drug Recovery Housing',
    primaryKeyword: 'Drug Recovery Housing',
    keywords: ['drug recovery house', 'drug recovery home', 'sober living for drug addiction'],
    title: 'Drug Recovery Housing in the Lehigh Valley, PA | PGSRH',
    description: 'PGSRH drug recovery housing offers structured, substance-free homes for men and women in recovery in the Lehigh Valley, PA. Housing and peer support \u2014 not treatment.',
    blurb: 'Structured, sober housing for people recovering from drug use.',
    heroSubtitle: 'Structured, substance-free housing for people rebuilding life in recovery from drug use \u2014 supported by peers and clear expectations.',
    intro: [
      'Recovery from drug use is easier in a stable, substance-free home surrounded by people working toward the same goal. PGSRH drug recovery housing provides that environment for men and women in the Lehigh Valley.',
      'Our focus is housing, accountability, and a recovery-supportive community \u2014 a dependable place to live while you continue your recovery with your own outside providers.',
    ],
    whoFor: [
      'People in recovery from drug use who need a sober, structured home',
      'Individuals leaving treatment or detox who need supportive housing',
      'Residents who benefit from peer accountability and routine',
      'Families seeking drug recovery housing for a loved one',
    ],
    sections: [
      { h: 'Housing and support, not treatment', p: [
        'PGSRH provides a safe place to live and a community of peers \u2014 not detox, rehab, therapy, or medical care. Residents who need clinical services get them through their own providers, while our home offers the day-to-day structure that supports recovery.',
        'That clear line is a strength: it lets our homes do what housing does best \u2014 provide stability, routine, and accountability.',
      ] },
      { h: 'A recovery-supportive environment', p: [
        'Living with peers keeps residents accountable and connected. Shared responsibilities, house expectations, and mutual support make it easier to stay focused on recovery.',
        'We can also point residents toward local meetings and outside resources when appropriate.',
      ] },
    ],
    faqs: [
      { q: 'Does PGSRH provide drug treatment or detox?', a: 'No. PGSRH provides recovery housing only \u2014 not detox, rehab, therapy, or medical services. Residents use their own outside providers for clinical care.' },
      { q: 'Who lives in drug recovery housing?', a: 'Adults in recovery who are committed to a substance-free lifestyle and willing to follow house expectations, in separate men\u2019s and women\u2019s homes.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I apply?', a: 'Apply online or call PGSRH to ask about availability and next steps.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/alcohol-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 2',
    name: 'Alcohol Recovery Housing',
    primaryKeyword: 'Alcohol Recovery Housing',
    keywords: ['alcohol recovery home', 'sober living for alcohol recovery', 'alcohol recovery house'],
    title: 'Alcohol Recovery Housing in the Lehigh Valley, PA | PGSRH',
    description: 'PGSRH alcohol recovery housing provides structured, alcohol-free homes for men and women in the Lehigh Valley, PA. Peer support and accountability \u2014 not treatment.',
    blurb: 'Alcohol-free, structured housing for people in recovery from alcohol.',
    heroSubtitle: 'Structured, alcohol-free housing for people in recovery \u2014 a stable home where sobriety is the shared standard.',
    intro: [
      'Staying sober is far easier in an environment where alcohol simply is not present and everyone shares the same commitment. PGSRH alcohol recovery housing provides an alcohol-free home for men and women in the Lehigh Valley.',
      'We provide housing and peer support \u2014 not clinical treatment \u2014 so residents can build routine and accountability while working their own recovery plan.',
    ],
    whoFor: [
      'People in recovery from alcohol who want an alcohol-free home',
      'Individuals stepping down from treatment who need stable housing',
      'Residents who value peer accountability and structure',
      'Families seeking alcohol recovery housing for a loved one',
    ],
    sections: [
      { h: 'An alcohol-free, supportive home', p: [
        'Our homes are kept free of alcohol and other substances, with clear expectations that all residents agree to. Living with peers who share the same goal removes a lot of the temptation and isolation that make early recovery hard.',
        'This is housing with support, not a treatment program \u2014 a place to live while you carry your recovery forward.',
      ] },
      { h: 'Building durable habits', p: [
        'Residents keep a routine \u2014 work, meetings, responsibilities \u2014 and support one another day to day. Those consistent habits are what make sobriety last.',
        'When clinical care is needed, residents access it through their own outside providers.',
      ] },
    ],
    faqs: [
      { q: 'Is alcohol recovery housing a treatment program?', a: 'No. It is alcohol-free, structured housing with peer support. PGSRH does not provide detox, rehab, therapy, or medical care.' },
      { q: 'Are the homes completely alcohol-free?', a: 'Yes. Every PGSRH home is kept free of alcohol and other substances, with clear house expectations.' },
      { q: 'Where are the homes located?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I get started?', a: 'Apply online or call PGSRH to ask about current availability.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/addiction-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 2',
    name: 'Addiction Recovery Housing',
    primaryKeyword: 'Addiction Recovery Housing',
    keywords: ['addiction recovery home', 'addiction recovery house', 'recovery housing for addiction'],
    title: 'Addiction Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH addiction recovery housing offers structured, substance-free homes for men and women in the Lehigh Valley, PA. Peer support and accountability \u2014 not treatment.',
    blurb: 'Broad, substance-free recovery housing for people healing from addiction.',
    heroSubtitle: 'Structured, substance-free housing for people in recovery from addiction of any kind \u2014 grounded in peer support and accountability.',
    intro: [
      'Whatever the substance, recovery from addiction takes a stable place to live and a community that understands. PGSRH addiction recovery housing offers exactly that for men and women in the Lehigh Valley.',
      'We provide housing and peer support \u2014 a dependable, substance-free home \u2014 while residents pursue clinical care through their own outside providers.',
    ],
    whoFor: [
      'Adults in recovery from any addiction who want a sober home',
      'People leaving treatment or detox who need supportive housing',
      'Residents who benefit from routine and peer accountability',
      'Families searching for addiction recovery housing for a loved one',
    ],
    sections: [
      { h: 'A home built for recovery', p: [
        'Our homes provide structure, shared responsibilities, and a substance-free environment. Living with peers in recovery creates accountability and connection that support long-term change.',
        'PGSRH does not provide treatment; we provide the stable housing that helps recovery take root.',
      ] },
      { h: 'A common internal-link hub', p: [
        'This page connects to our drug, alcohol, and specific-substance recovery housing pages, as well as to our gender-specific and location homes.',
        'If you\u2019re not sure where to start, contact us and we\u2019ll point you in the right direction.',
      ] },
    ],
    faqs: [
      { q: 'Does addiction recovery housing include treatment?', a: 'No. It is housing with peer support, not clinical treatment. PGSRH does not provide detox, rehab, therapy, or medical services.' },
      { q: 'Which addictions do you support recovery from?', a: 'Our homes support adults in recovery regardless of substance, as long as they are committed to a substance-free lifestyle and house expectations.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'Is help with cost available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/substance-abuse-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Substance Abuse Recovery Housing',
    primaryKeyword: 'Substance Abuse Recovery Housing',
    keywords: ['substance abuse recovery home', 'substance abuse sober living', 'substance abuse recovery housing scholarships'],
    title: 'Substance Abuse Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH substance abuse recovery housing offers structured, substance-free homes with peer support for men and women in the Lehigh Valley, PA. Housing \u2014 not treatment.',
    blurb: 'Substance-free housing supporting recovery from substance use.',
    heroSubtitle: 'Structured, substance-free housing that supports recovery from substance use \u2014 stability, routine, and peer accountability.',
    intro: [
      'Recovery from substance use needs more than good intentions \u2014 it needs a stable environment. PGSRH substance abuse recovery housing gives men and women a substance-free home and a supportive peer community in the Lehigh Valley.',
      'This is housing support, not clinical treatment. Residents live in a structured home while receiving any clinical care from their own outside providers.',
    ],
    whoFor: [
      'People in recovery from substance use who need a sober home',
      'Individuals transitioning from treatment or detox',
      'Residents who do best with structure and accountability',
      'Families and referral partners arranging supportive housing',
    ],
    sections: [
      { h: 'Housing that supports recovery', p: [
        'Our homes provide a substance-free environment, house expectations, and peer support \u2014 the everyday framework that helps recovery hold. Residents share responsibilities and keep one another accountable.',
        'We are careful to stay in our lane: PGSRH offers housing, not medical or clinical services.',
      ] },
      { h: 'A stable base for the work ahead', p: [
        'With a dependable place to live, residents can focus on work, meetings, and rebuilding relationships. Stability makes the rest of recovery possible.',
        'Explore our related pages for specific substances and locations, or contact us to discuss the right fit.',
      ] },
    ],
    faqs: [
      { q: 'Is this a treatment program?', a: 'No. Substance abuse recovery housing is structured, sober housing with peer support \u2014 not detox, rehab, therapy, or medical care.' },
      { q: 'Who is it for?', a: 'Adults in recovery from substance use who are committed to a substance-free lifestyle and willing to follow house expectations.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'Is there funding help?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  }),
  mk({
    slug: '/opioid-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Opioid Recovery Housing',
    primaryKeyword: 'Opioid Recovery Housing',
    keywords: ['opioid recovery home', 'opioid sober living', 'opioid recovery house', 'opioid recovery housing scholarships'],
    title: 'Opioid Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH opioid recovery housing offers structured, substance-free homes with peer support for men and women in the Lehigh Valley, PA. Housing and support \u2014 not treatment.',
    blurb: 'Substance-free housing supporting recovery from opioid use.',
    heroSubtitle: 'A stable, substance-free home and supportive community for people in recovery from opioid use.',
    intro: [
      'Recovery from opioid use is often a long road, and a stable place to live can make a real difference. PGSRH opioid recovery housing provides a substance-free home and peer support for men and women in the Lehigh Valley.',
      'We provide housing and community \u2014 not detox, medication management, or clinical treatment. Residents work with their own outside providers for any medical or clinical needs.',
    ],
    whoFor: [
      'People in recovery from opioid use who need a sober home',
      'Individuals leaving treatment or detox who need supportive housing',
      'Residents who benefit from structure and peer accountability',
      'Families seeking opioid recovery housing for a loved one',
    ],
    sections: [
      { h: 'A supportive, substance-free environment', p: [
        'Living with peers who understand the challenges of opioid recovery reduces isolation and builds accountability. Our homes provide clear expectations and a substance-free setting so residents can focus on staying well.',
        'When appropriate, we can point residents toward outside meetings and community resources.',
      ] },
      { h: 'Clear boundaries around clinical care', p: [
        'PGSRH does not provide detox, medication-assisted treatment, or medical services. Residents coordinate that care with their own providers. Our role is to offer the dependable housing and community that support it.',
        'This clarity protects both the resident and the integrity of our recovery homes.',
      ] },
    ],
    faqs: [
      { q: 'Does PGSRH provide MAT or medical care?', a: 'No. PGSRH provides recovery housing only \u2014 not medication-assisted treatment, detox, or medical services. Residents coordinate clinical care with their own providers.' },
      { q: 'Can residents on a prescribed recovery medication live here?', a: 'Clinical decisions are between residents and their providers. Contact PGSRH to discuss house expectations and your situation.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  }),
  mk({
    slug: '/fentanyl-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Fentanyl Recovery Housing',
    primaryKeyword: 'Fentanyl Recovery Housing',
    keywords: ['fentanyl recovery home', 'fentanyl sober living', 'housing after fentanyl addiction'],
    title: 'Fentanyl Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH provides structured, substance-free recovery housing for men and women rebuilding life after fentanyl use in the Lehigh Valley, PA. Housing and support \u2014 not treatment.',
    blurb: 'Substance-free housing supporting recovery after fentanyl use.',
    heroSubtitle: 'A stable, substance-free home and supportive community for people rebuilding after fentanyl use.',
    intro: [
      'Fentanyl has made recovery more urgent and more fragile than ever, and a safe place to live matters enormously. PGSRH provides substance-free recovery housing and peer support for men and women in the Lehigh Valley.',
      'We offer housing and community \u2014 not detox, medical care, or clinical treatment. Residents receive any clinical services through their own outside providers.',
    ],
    whoFor: [
      'People rebuilding life after fentanyl use who need a sober home',
      'Individuals leaving treatment or detox who need stable housing',
      'Residents who benefit from structure and peer support',
      'Families seeking a safe recovery home for a loved one',
    ],
    sections: [
      { h: 'Stability during a fragile stage', p: [
        'The period after treatment or detox can be especially high-risk. A substance-free home with peers, routine, and accountability gives residents a far steadier place to stand during this stage.',
        'Our homes are kept free of substances, with clear expectations everyone follows.',
      ] },
      { h: 'Housing, not treatment', p: [
        'PGSRH does not provide detox, medical care, or clinical treatment. We provide the dependable housing and community that support recovery, while clinical care stays with a resident\u2019s own providers.',
        'If you\u2019re coming directly from a program, see our after-detox and after-treatment pages.',
      ] },
    ],
    faqs: [
      { q: 'Does PGSRH treat fentanyl addiction?', a: 'No. PGSRH provides recovery housing only \u2014 not detox, medical care, or clinical treatment. Residents use their own outside providers for clinical care.' },
      { q: 'Is this safe housing after detox?', a: 'Our homes provide a stable, substance-free environment with peer support, which many people seek after completing detox elsewhere.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I apply?', a: 'Apply online or call PGSRH to ask about current availability and next steps.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/cocaine-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Cocaine Recovery Housing',
    primaryKeyword: 'Cocaine Recovery Housing',
    keywords: ['cocaine recovery home', 'cocaine sober living', 'recovery house for cocaine'],
    title: 'Cocaine Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH provides structured, substance-free recovery housing for men and women in recovery from cocaine use in the Lehigh Valley, PA. Housing and support \u2014 not treatment.',
    blurb: 'Substance-free housing supporting recovery from cocaine use.',
    heroSubtitle: 'Structured, substance-free housing and a supportive community for people in recovery from cocaine use.',
    intro: [
      'Recovery from cocaine use is strengthened by structure, routine, and a community that keeps you accountable. PGSRH provides substance-free recovery housing and peer support for men and women in the Lehigh Valley.',
      'This is housing support, not clinical treatment. Residents live in a structured home while pursuing any clinical care through their own providers.',
    ],
    whoFor: [
      'People in recovery from cocaine use who want a sober home',
      'Individuals leaving treatment who need supportive housing',
      'Residents who do best with routine and accountability',
      'Families seeking cocaine recovery housing for a loved one',
    ],
    sections: [
      { h: 'Structure that supports recovery', p: [
        'A predictable routine and a substance-free home help residents rebuild stability. Living with peers in recovery adds accountability and encouragement that are hard to find alone.',
        'Our homes have clear expectations that everyone agrees to from day one.',
      ] },
      { h: 'Educational and supportive', p: [
        'We keep this page educational and supportive \u2014 focused on what recovery housing can offer, not on clinical claims. PGSRH does not provide treatment or medical care.',
        'Explore our related substance and location pages, or reach out with questions.',
      ] },
    ],
    faqs: [
      { q: 'Does PGSRH provide cocaine addiction treatment?', a: 'No. PGSRH provides recovery housing only \u2014 not detox, rehab, therapy, or medical services.' },
      { q: 'Who lives here?', a: 'Adults in recovery who are committed to a substance-free lifestyle and willing to follow house expectations.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I start?', a: 'Apply online or call PGSRH to ask about availability.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/meth-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Meth Recovery Housing',
    primaryKeyword: 'Meth Recovery Housing',
    keywords: ['meth recovery home', 'meth sober living', 'recovery house for meth'],
    title: 'Meth Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH provides structured, substance-free recovery housing for men and women in recovery from methamphetamine use in the Lehigh Valley, PA. Housing and support \u2014 not treatment.',
    blurb: 'Substance-free housing supporting recovery from meth use.',
    heroSubtitle: 'A stable, substance-free home and supportive community for people in recovery from methamphetamine use.',
    intro: [
      'Recovery from methamphetamine use often benefits from long-term structure and steady support. PGSRH provides substance-free recovery housing and peer community for men and women in the Lehigh Valley.',
      'We provide housing and support \u2014 not detox, medical care, or clinical treatment. Residents access clinical care through their own providers.',
    ],
    whoFor: [
      'People in recovery from meth use who need a sober, structured home',
      'Individuals leaving treatment or detox who need supportive housing',
      'Residents who do best with routine and peer accountability',
      'Families seeking meth recovery housing for a loved one',
    ],
    sections: [
      { h: 'Long-term structure and support', p: [
        'A stable home, a steady routine, and accountable peers give residents room to rebuild over time. Our homes are substance-free with clear expectations that support recovery day to day.',
        'For those who want an extended stay, see our long-term recovery housing page.',
      ] },
      { h: 'Housing, not treatment', p: [
        'PGSRH does not provide detox, medical care, or clinical treatment. Our role is dependable housing and community; clinical care stays with a resident\u2019s own providers.',
        'Reach out to discuss expectations and availability for your situation.',
      ] },
    ],
    faqs: [
      { q: 'Does PGSRH treat meth addiction?', a: 'No. PGSRH provides recovery housing only \u2014 not detox, medical care, or clinical treatment.' },
      { q: 'Is long-term housing available?', a: 'Length of stay is flexible and based on individual needs. See our long-term recovery housing page or contact us.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I apply?', a: 'Apply online or call PGSRH to ask about availability.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/drug-and-alcohol-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Drug and Alcohol Recovery Housing',
    primaryKeyword: 'Drug and Alcohol Recovery Housing',
    keywords: ['drug and alcohol sober living', 'drug and alcohol recovery homes', 'drug and alcohol recovery housing scholarships'],
    title: 'Drug and Alcohol Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH drug and alcohol recovery housing offers structured, substance-free homes for men and women in the Lehigh Valley, PA. Peer support and accountability \u2014 not treatment.',
    blurb: 'Combined drug and alcohol recovery housing with peer support.',
    heroSubtitle: 'Structured, substance-free homes for people in recovery from drugs and alcohol \u2014 supported by peers and clear expectations.',
    intro: [
      'For many people, recovery involves both drugs and alcohol, and a home free of every substance is what they need. PGSRH drug and alcohol recovery housing provides that for men and women in the Lehigh Valley.',
      'We offer housing and peer support \u2014 a substance-free home with structure \u2014 while residents pursue any clinical care through their own outside providers.',
    ],
    whoFor: [
      'People in recovery from drugs and/or alcohol who want a sober home',
      'Individuals transitioning from treatment or detox',
      'Residents who benefit from structure and peer accountability',
      'Families and referral partners arranging supportive housing',
    ],
    sections: [
      { h: 'A fully substance-free home', p: [
        'Our homes are kept free of drugs and alcohol, with clear expectations that all residents agree to. Living with peers who share that commitment builds accountability and community.',
        'This is a strong supporting home base for people working their recovery plan.',
      ] },
      { h: 'Connecting the pieces', p: [
        'This page links naturally to our drug and alcohol recovery housing pages, as well as gender-specific and location homes.',
        'If you\u2019re unsure where to begin, contact us and we\u2019ll help you find the right home.',
      ] },
    ],
    faqs: [
      { q: 'Is this a treatment program?', a: 'No. It is structured, substance-free housing with peer support \u2014 not detox, rehab, therapy, or medical care.' },
      { q: 'Are both drugs and alcohol prohibited?', a: 'Yes. Every PGSRH home is fully substance-free, with clear house expectations.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  }),
  mk({
    slug: '/long-term-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Long-Term Recovery Housing',
    primaryKeyword: 'Long-Term Recovery Housing',
    keywords: ['long term sober living', 'long term recovery house', 'extended recovery housing'],
    title: 'Long-Term Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH long-term recovery housing gives men and women a stable, sober home for an extended recovery journey in the Lehigh Valley, PA. Structure and peer support \u2014 not treatment.',
    blurb: 'Extended, stable recovery housing for a longer journey.',
    heroSubtitle: 'A stable, sober home for people who want an extended recovery stay \u2014 structure and support over the long haul.',
    intro: [
      'Recovery is not on a fixed timeline, and some people do best with a longer, steadier stay. PGSRH long-term recovery housing offers men and women an extended, substance-free home in the Lehigh Valley.',
      'We provide the housing and community; residents pursue any clinical care with their own providers. Length of stay is flexible and based on individual needs.',
    ],
    whoFor: [
      'People who want an extended, stable recovery home',
      'Individuals who do better with a longer runway before independent living',
      'Residents rebuilding careers, relationships, and stability over time',
      'Families seeking long-term recovery housing for a loved one',
    ],
    sections: [
      { h: 'Why longer stays help some people', p: [
        'More time in a supportive, structured home means more time to rebuild routine, employment, savings, and relationships before living independently. For many, that longer runway makes recovery more durable.',
        'Our homes keep the same substance-free standards and peer support throughout a resident\u2019s stay.',
      ] },
      { h: 'Flexible length of stay', p: [
        'PGSRH does not impose a rigid clock. Length of stay depends on progress and individual needs \u2014 we\u2019ll talk through what makes sense for you.',
        'Contact us to discuss expectations and availability for a longer-term stay.',
      ] },
    ],
    faqs: [
      { q: 'How long can I stay?', a: 'Length of stay is flexible and based on individual progress and needs. Contact PGSRH to discuss what fits your situation.' },
      { q: 'Is long-term recovery housing a treatment program?', a: 'No. It is extended, sober housing with peer support \u2014 not clinical treatment.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I apply?', a: 'Apply online or call PGSRH to ask about availability.' },
    ],
    funding: false,
  }),
  mk({
    slug: '/peer-support-recovery-housing/',
    category: 'Substance-Specific Page', tier: 'Tier 3',
    name: 'Peer Support Recovery Housing',
    primaryKeyword: 'Peer Support Recovery Housing',
    keywords: ['peer support sober living', 'recovery housing peer support', 'sober living accountability'],
    title: 'Peer Support Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH recovery housing is built on peer support and accountability. Live alongside others in recovery in a structured, sober home in the Lehigh Valley, PA.',
    blurb: 'Recovery housing centered on peer support and accountability.',
    heroSubtitle: 'Recovery housing built on peer support \u2014 living alongside others who understand, encourage, and hold you accountable.',
    intro: [
      'One of the most powerful parts of recovery housing is the people. PGSRH homes are built around peer support: residents live alongside others in recovery who understand the journey and keep one another accountable.',
      'This page explains how peer support and accountability work inside our substance-free, structured homes in the Lehigh Valley.',
    ],
    whoFor: [
      'People who recover best in a supportive community',
      'Individuals who value accountability from peers',
      'Residents rebuilding connection after isolation',
      'Anyone who wants a sober home with genuine mutual support',
    ],
    sections: [
      { h: 'How peer support works day to day', p: [
        'Peer support is not a formal service here \u2014 it is the culture of the home. Residents check in on one another, share responsibilities, celebrate milestones, and speak up when someone is struggling.',
        'That everyday accountability is one of the biggest reasons recovery housing helps.',
      ] },
      { h: 'Support within a clear structure', p: [
        'Peer support works best inside a structured home with clear expectations. Together they create a setting that is both caring and dependable.',
        'PGSRH provides housing and this peer community \u2014 not clinical treatment. Residents use their own outside providers for clinical care.',
      ] },
    ],
    faqs: [
      { q: 'Is peer support the same as counseling?', a: 'No. Peer support is mutual encouragement and accountability among residents in recovery. It is not counseling or clinical treatment, which PGSRH does not provide.' },
      { q: 'Do I have to participate in the community?', a: 'Being an accountable, engaged member of the household is part of what makes our homes work. Specific expectations are explained during the application process.' },
      { q: 'Where are the homes?', a: 'In the Lehigh Valley: Whitehall for men, and Catasauqua for women.' },
      { q: 'How do I apply?', a: 'Apply online or call PGSRH to ask about availability.' },
    ],
    funding: false,
  }),
];

export default pages;
